import { useMutation, useQueryClient } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'

import { getBasePaySchedulesQuery } from './payroll/utils'
import { type PaySchedule } from '../../types/payroll'
type UpdatePayScheduleParams = Partial<PaySchedule> & { id: string }

export function useUpdatePaySchedule () {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (params: UpdatePayScheduleParams) => {
      const response = await fetchWithHeaders(`/api/web/payroll/pay_schedules/${params.id}`, {
        method: 'PUT',
        body: JSON.stringify(params),
      })

      if (!response.ok) {
        const error = await response.json()
        throw new Error(error.message || 'Failed to update pay schedule')
      }

      return response.json()
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getBasePaySchedulesQuery() })
    },
  })
}
